import { Box } from "@mantine/core";
import { useForm } from "@mantine/form";
import { add } from "date-fns";
import { Tabs } from "@mantine/core";
import { IconList, IconChartLine } from "@tabler/icons-react";
import classes from "../../../Chart.module.css";
import { useState } from "react";
import { CashflowItems } from "../../../backend/types-v2";
import {
  BalanceDay,
  buildBalanceByDay,
  buildLedger,
} from "../../../backend/build-ledger";
import { Instant, LocalDate, ZoneId } from "@js-joda/core";
import { Table2 } from "./TransactionsTable";
import { DataChart2 } from "./Chart2";
import { iconStyle } from "./Icons";
import { FormV2 } from "./Form2";
import { DataTablesV2 } from "./DataTables";
import { poundsToPence } from "../../../utils";

const chart = "chart";
const list = "list";

export type PresentationalTransaction = BalanceDay & {
  toDate: LocalDate;
};

export type FormInputs = {
  startDate: Date;
  endDate: Date;
  initialBalance: string;
};

const dateToLocalDate = (date: Date) =>
  LocalDate.ofInstant(
    Instant.ofEpochMilli(date.getTime()),
    ZoneId.systemDefault(),
  );

export function ProjectorV2({ items }: { items: CashflowItems }) {
  const [selectedTab, setSelectedTab] = useState<typeof chart | typeof list>(
    chart,
  );

  const initialStartDate = new Date();
  const initialEndDate = add(initialStartDate, { months: 1 });

  const form = useForm<FormInputs>({
    initialValues: {
      startDate: initialStartDate,
      endDate: initialEndDate,
      initialBalance: "250",
    },
  });

  const localDateStart = dateToLocalDate(form.values.startDate);
  const localDateEnd = dateToLocalDate(form.values.endDate);

  const ledger = buildLedger(localDateStart, localDateEnd, items, true);
  const balances = buildBalanceByDay(
    ledger,
    localDateStart,
    localDateEnd,
    poundsToPence(Number(form.values.initialBalance)),
  );

  const inititalValue: PresentationalTransaction[] = [];

  const reducedTransactions = balances
    .map((x) => ({ ...x, toDate: x.date }))
    .reduce(
      (
        accumulatedValues: PresentationalTransaction[],
        nextValue: PresentationalTransaction,
      ) => {
        const accumulatedLength = accumulatedValues.length;
        if (accumulatedLength > 0) {
          if (
            nextValue.transactions.length === 0 &&
            accumulatedValues[accumulatedLength - 1].transactions.length === 0
          ) {
            const nextAccumulatedValues = accumulatedValues.map(
              (item, index) => {
                if (index === accumulatedLength - 1) {
                  return { ...item, toDate: nextValue.date };
                }

                return item;
              },
            );

            return nextAccumulatedValues;
          }
        }

        return [...accumulatedValues, nextValue];
      },
      inititalValue,
    );

  return (
    <Box mx="auto">
      <Tabs mt={12} variant="unstyled" value={selectedTab} classNames={classes}>
        <FormV2 form={form} />
        <Box
          style={{
            marginTop: "24px",
            marginLeft: "auto",
            marginRight: "auto",
            width: "70%",
            minWidth: "280px",
            maxWidth: "600px",
            border: "1px solid",
          }}
        >
          <Tabs.List grow>
            <Tabs.Tab
              value={chart}
              leftSection={<IconChartLine style={iconStyle} />}
              onClick={() => setSelectedTab(chart)}
            >
              Chart
            </Tabs.Tab>
            <Tabs.Tab
              value={list}
              leftSection={<IconList style={iconStyle} />}
              onClick={() => setSelectedTab(list)}
            >
              List
            </Tabs.Tab>
          </Tabs.List>
        </Box>
        <Tabs.Panel pt={42} value={chart}>
          <DataChart2 transactions={reducedTransactions} />
        </Tabs.Panel>

        <Tabs.Panel pt={42} value={list}>
          <Table2 transactions={reducedTransactions} />
        </Tabs.Panel>
      </Tabs>
      <DataTablesV2 />
    </Box>
  );
}
